module.exports = __webpack_public_path__ + "static/dietlein@2x.ed969f7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/avatars/dietlein@2x.jpg
// module id = 146
// module chunks = 35783957827783 263791100135453